import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { RootModule } from './root.module';

import 'moment/min/locales.min';
import 'moment-timezone';
import 'zone.js';
import 'chart.js/auto';
import { Chart } from 'chart.js';
import { appsmartBlue } from '@shared/AppConsts';
import { ensurePostHogInitialized } from '@shared/analytics/posthog';

enableProdMode();
ensurePostHogInitialized();

// Fix Chart.js default colors - set to AppSmart blue theme for ng2-charts compatibility
Chart.defaults.color = appsmartBlue;
Chart.defaults.backgroundColor = appsmartBlue;

const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(RootModule);
};

bootstrap();
